<script lang="ts">
  import {Button} from '@px/button';
  import {stringify} from 'query-string';
  import {PATHS} from '@/const/paths';
  import {SERVICES} from '@/const/services';
  import {fixLink$} from '@/store/lang';
  import TransitionWrap from '../TransitionWrap.svelte';
  import {amount$, currency$, formatedData$, network$} from '../wallet-deposit/streams';
  import lang from '../DepositDrawer.lang';

  export let LG;

  const image = `${SERVICES.STATIC_URL}/pubimg/` + '4e3f788c39071183f04726234210d28197bb33d5f1d005f4b00c1e78ba82d634.png';

  $: networkName = getDepositNetworkName($formatedData$, $currency$, $network$);

  function getDepositNetworkName(formatedData, currency, network) {
    if (!formatedData) {
      return '';
    }
    const tokenKey = `${currency}_${network}`;
    const token = formatedData.tokenMap[tokenKey] || {};
    return token.displayName || '';
  }

  function handleViewDepositHistoryClick() {
    const tab = 'Deposit';
    const link = `${$fixLink$(PATHS.ASSETS_DEPOSIT_WITHDRAW_HISTORY.pathname)}?${stringify({tab})}`;
    window.location.assign(link);
  }
</script>

<style>
  .deposit-main {
    margin-top: 100px;
  }
  .deposit-box {
    display: grid;
    grid-template-columns: 1fr auto;
    row-gap: 12px;
  }
  .item-value {
    color: #1b2025;
  }
  .deposit-result :global(.btn) {
    margin-top: 32px;
    border-radius: 40px;
  }
</style>

<TransitionWrap>
  <div class="deposit-result wp100">
    <h1 class="p0 T1 f32 fw2">{LG(lang.Web3WalletDepsot)}</h1>

    <div class="deposit-main df fdc aic jcc">
      <img width="86" height="86" src={image} alt="" srcset="" />
      <div class="mt24 T2 b f20 tc">{LG(lang.SuccessTips)}</div>
    </div>

    <div class="deposit-box mt24">
      <div class="T4 f16">{LG(lang.DepositAmount)}</div>
      <div class="item-value f16 fw2">{$amount$} {$currency$}</div>

      <div class="T4 f16">{LG(lang.DepositNetwork)}</div>
      <div class="item-value f16 fw2">{networkName}</div>
    </div>

    <div class="f14 T3 mt12">
      <span class="T1 fw2">{LG(lang.Note)}：</span><span>{LG(lang.SuccessNotes)}</span>
    </div>

    <Button newRadius type="primary" class="btn wp100 f16 fw2" on:click={handleViewDepositHistoryClick}>
      {LG(lang.ViewDepositHistory)}
    </Button>
  </div>
</TransitionWrap>
